import { Col, Container, If, Input, Link, Row, Space, Spacer, Text } from '@app/components'
import { IStore } from '@app/redux'
import { getThemeColors } from '@app/theme'
import { formatWalletAddress, toCurrency } from '@app/utils'
import { Button, Segmented } from 'antd'
import { CustomSelect } from 'collections/buy-and-sell/collections/custom-select'
import { TestWaitContract, WaitContract } from 'libs/data/contracts'
import useApproved from 'libs/services/hooks/useApproved'
import useLocked from 'libs/services/hooks/useLocked'
import useWaitBalance from 'libs/services/hooks/useWaitBalance'
import React, { useState } from 'react'
import { useSelector } from 'react-redux'
import { useAccount, useChainId } from 'wagmi'

import { WaitV2Icon } from '~public'

import { Summary } from '../summary'

export const Lock: React.FC<{ isForDrawer?: boolean }> = ({ isForDrawer = false }) => {
  const { theme } = useSelector((state: IStore) => state)
  const COLORS = getThemeColors(theme.value)

  const [lockingTokens, setLockingTokens] = useState(0)
  const [approvingTokens, setApprovingTokens] = useState(0)

  const tokenDecimals = 8
  const { address } = useAccount()

  const waitBalance = Number(useWaitBalance().value) / 10 ** tokenDecimals
  const locked = Number(useLocked().value) / 10 ** tokenDecimals
  const approvedToken = Number(useApproved().value) / 10 ** tokenDecimals
  const chainId = useChainId()

  const [selectedAsset, setSelectedAsset] = useState<any>({
    id: '1',
    name: chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) ? 'eWAIT' : 'Wait',
    icon: <WaitV2Icon style={{ height: 25, width: 25 }} />,
    val: 'WAIT',
  })

  const ASSET_LIST = [
    {
      id: '1',
      name: chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) ? 'eWAIT' : 'Wait',
      icon: <WaitV2Icon style={{ height: 25 }} />,
      val: 'WAIT',
    },
  ]

  const DISCOUNTS = [
    {
      value: 0,
      discount: chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) ? 1 : 4,
    },
    {
      value: 1000,
      discount: chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) ? 0.75 : 3,
    },
    {
      value: 10000,
      discount: chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) ? 0.5 : 2,
    },
    {
      value: 100000,
      discount: chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) ? 0.25 : 1,
    },
  ]

  const selectAmount = (v) => {
    setLockingTokens(Number(v))
    setApprovingTokens(Number(v))
  }
  const addy = () => {
    if (address != undefined) {
      return formatWalletAddress(address)
    } else {
      return 'Connect Wallet!'
    }
  }
  const getSegmentedFontColor = (v) => {
    if (v - locked === lockingTokens) {
      return { color: COLORS.WHITE }
    } else return {}
  }

  const getSegmentedOptions = () => {
    return DISCOUNTS.filter(function (i) {
      return i.value - locked > 0
    }).map((item) => {
      const isActive = item.value - locked === lockingTokens // Check active state
      return {
        label: (
          <Container
            padding="10px 4px 4px 4px"
            style={{
              border: isActive ? `2px solid ${COLORS.PRIMARY}` : `1px solid ${COLORS.darkGrey}`, // Active border
              borderRadius: '8px', // Rounded corners
              cursor: 'pointer', // Change cursor to pointer
              backgroundColor: isActive ? COLORS.PRIMARY : COLORS.WHITE, // Highlight active option
              color: isActive ? COLORS.WHITE : COLORS.darkGrey, // Text color
              textAlign: 'center',
              transition: 'all 0.3s ease', // Smooth transition
            }}
          >
            <Text style={{ display: 'block', ...getSegmentedFontColor(item.value) }}>
              {toCurrency(item.value - locked, false)}
            </Text>
            <Text style={getSegmentedFontColor(item.value)}>Tier: {item.discount}</Text>
          </Container>
        ),
        value: item.value - locked,
      }
    })
  }

  const calculateNewDiscountValue = () => {
    return DISCOUNTS.find((item) => item.value - locked === lockingTokens)?.discount
  }

  const calculateCurrentDiscountValue = () => {
    return DISCOUNTS.find((item) => item.value === locked)?.discount
  }

  if (
    (chainId != parseInt(process.env.NEXT_PUBLIC_PULSECHAIN) &&
      chainId != parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN)) ||
    address == undefined
  ) {
    return (
      <Row>
        <Col span={24} md={24} lg={isForDrawer ? 24 : 12}>
          <Space direction="vertical">
            <Text strong>Please switch to PulseChain Mainnet or Ethereum Mainnet</Text>
          </Space>
        </Col>
      </Row>
    )
  }

  const addToken = async () => {
    if (window.ethereum != undefined) {
      const waitAddress = process.env.NEXT_PUBLIC_ENV == 'development' ? TestWaitContract.address : WaitContract.address

      const tokenSymbol = process.env.NEXT_PUBLIC_ENV == 'development' ? 'tok' : 'WAIT'
      const tokenDecimals = 8 // The decimals of the token
      // FIX
      const tokenImage = 'wait-v2-icon.png' // Token image URL (optional)

      try {
        // wasAdded is a boolean. It's true if the token was added to the wallet, and false if it was not
        const wasAdded = await (window as any).ethereum.request({
          method: 'wallet_watchAsset',
          params: {
            type: 'ERC20', // Initially, only ERC20 tokens are supported
            options: {
              address: waitAddress, // The address of the token contract
              symbol: tokenSymbol, // A string symbol of the token
              decimals: tokenDecimals, // The number of decimals the token uses
              image: tokenImage, // A string URL of the token logo
            },
          },
        })

        if (wasAdded) {
          // eslint-disable-next-line no-console
          console.log('Token was added to wallet!')
        } else {
          // eslint-disable-next-line no-console
          console.log('Token was not added to wallet.')
        }
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error(error)
      }
    }
  }

  return (
    <Row>
      <Col span={24} md={24} lg={isForDrawer ? 24 : 12}>
        {process.env.NEXT_PUBLIC_BUY_SELL_ON == 'false' ? (
          <Text>
            These features are currently unavailable due to
            <Link href="https://0xcoast.com/2023/06/temporary-pause-on-beta-functions" target="_blank">
              {' '}
              maintenance
            </Link>
          </Text>
        ) : (
          <Row>
            <Col style={{ width: '100%' }}>
              <Text>Select Asset</Text>
              <Spacer value={10} />
              <CustomSelect type="Asset" selected={selectedAsset} setSelected={setSelectedAsset} list={ASSET_LIST} />
            </Col>

            <Col style={{ width: '100%' }}>
              <Text>Available Tokens</Text>
              <Spacer value={10} />
              <Input disabled defaultValue={toCurrency(0, false)} value={waitBalance} />
            </Col>

            <If
              condition={
                DISCOUNTS.find((item) => item.discount === 1)?.value > locked &&
                chainId == parseInt(process.env.NEXT_PUBLIC_PULSECHAIN)
              }
            >
              <Col style={{ width: '100%' }}>
                <Text>Lock Tokens</Text>
                <Spacer value={10} />
                <Segmented
                  style={{ backgroundColor: COLORS.baseBgColor }}
                  size="small"
                  block
                  value={lockingTokens}
                  options={getSegmentedOptions()}
                  onChange={(v) => selectAmount(v)}
                />
              </Col>
            </If>

            <If
              condition={
                DISCOUNTS.find((item) => item.discount === 0.25)?.value > locked &&
                chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN)
              }
            >
              <Col style={{ width: '100%' }}>
                <Text>Lock Tokens</Text>
                <Spacer value={10} />
                <Segmented
                  size="small"
                  block
                  value={lockingTokens}
                  options={getSegmentedOptions()}
                  onChange={(v) => selectAmount(v)}
                />
              </Col>
            </If>

            <Col style={{ width: '100%' }}>
              <Row>
                {window.ethereum != undefined ? (
                  <Col style={{ width: '50%' }}>
                    <Button block onClick={() => addToken()}>
                      Add To Wallet <WaitV2Icon style={{ width: 25, marginLeft: 8 }} />
                    </Button>
                  </Col>
                ) : (
                  <></>
                )}

                <Col style={{ width: '50%' }}>
                  {chainId == parseInt(process.env.NEXT_PUBLIC_PULSECHAIN) ? (
                    <Button block href="https://app.0xcoast.com/buy" target="_blank">
                      Buy
                    </Button>
                  ) : (
                    <Button
                      block
                      href="https://app.uniswap.org/#/tokens/mainnet/0x26179a4d4B58b4456F28d19507546596c9058ee5"
                      target="_blank"
                    >
                      Buy on Uniswap
                    </Button>
                  )}
                </Col>
              </Row>
              <Spacer />
              <Row>
                <Col style={{ width: '100%' }}>
                  <Button block href="https://app.0xcoast.com/fees#holidayDiv">
                    About Fee Tiers
                  </Button>
                </Col>
              </Row>
            </Col>
          </Row>
        )}
      </Col>

      {process.env.NEXT_PUBLIC_BUY_SELL_ON == 'false' ? (
        <></>
      ) : (
        <Col span={24} md={24} lg={isForDrawer ? 24 : 12}>
          <Summary
            wallet={addy()}
            lockingTokens={lockingTokens}
            setLockingTokens={setLockingTokens}
            approvingTokens={approvingTokens}
            setApprovingTokens={setApprovingTokens}
            lockedToken={locked}
            approvedToken={approvedToken}
            currentDiscount={calculateCurrentDiscountValue()}
            newDiscount={calculateNewDiscountValue()}
            asset={selectedAsset}
            balance={waitBalance}
            chain={chainId}
            title={chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) ? 'eWait' : 'Wait'}
          />
        </Col>
      )}
    </Row>
  )
}
